'use strict';

var EditDmz = require('actionGroups/dmz/Dmz');

module.exports = {
  Model: EditDmz,
};
